<template>
    <div v-show="isModalEAdminVisible">
        <transition name="slide">
            <div class="modal-mask">
                <div class="modal-dialog modal-dialog-slideout modal-lg">
                    <div class="modal-content p-2">
                        <div class="modal-header">
                          <div class="width-100">
                            <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                            <button type="button" class="close float-right" @click="hide">
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="clearfix"></div>
                          </div>

                        </div>
                        <div class="modal-body">
                          <div class="row mb-4">
                            <div class="col-9 pl-3">
                              <div class="h3 d-inline mr-2 text-uppercase">Create New Enterprise Admin</div>
                              
                            </div>
                          </div>                            
                            <flash-message autoHide variant="success"></flash-message>
                            <b-alert
                              :show="dismissCountDown"
                              dismissible
                              variant="success"
                              @dismissed="dismissCountDown=0"
                              @dismiss-count-down="countDownChanged"
                              >
                              {{ success_message }}
                            </b-alert>
                            <form @submit.prevent="createNewEnterpriseAdmin" v-if="!isSuccessPanel">
                                <div class="row">
                                    <div class="col-12">
                                        
                                        <input
                                            type="text"
                                            id="first_name"
                                            class="col-12 col-sm-12 input-height-35 form-control"
                                            ref="first_name"
                                            name="first_name"
                                            v-model="firstName"
                                            v-validate="{ rules: { required: true, regex: nameRegex() } }"
                                            placeholder="Enter First Name"
                                            maxlength="250"
                                            autocomplete="off">
                                        <div v-if="verrors.firstByRule('first_name', 'required')" class="margin-bottom-5 validate-warning-msg">First Name is required</div>
                                         <div v-if="verrors.firstByRule('first_name', 'regex')" class="margin-bottom-5 validate-warning-msg">First Name should only contain - and _</div>
                                        
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 margin-t-10">
                                        
                                        <input
                                            type="text"
                                            id="last_name"
                                            class="col-12 col-sm-12 input-height-35 form-control"
                                            ref="last_name"
                                            name="last_name"
                                            v-model="lastName"
                                            v-validate="{ rules: { required: true, regex: nameRegex() } }"
                                            placeholder="Enter Last Name"
                                            maxlength="250"
                                            autocomplete="off">
                                        <div v-if="verrors.firstByRule('last_name', 'required')" class="margin-bottom-5 validate-warning-msg">Last Name is required</div>
                                        <div v-if="verrors.firstByRule('last_name', 'regex')" class="margin-bottom-5 validate-warning-msg">Last Name should only contain - and _</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 margin-t-10">
                                        
                                        <input
                                            type="text"
                                            id="email"
                                            class="col-12 col-sm-12 input-height-35 form-control"
                                            ref="email"
                                            name="email"
                                            v-model="adminEmail"
                                            v-validate="{ rules: { required: true } }"
                                            placeholder="Enter Email"
                                            maxlength="250"
                                            autocomplete="off">
                                        <div v-if="verrors.firstByRule('email', 'required')" class="margin-bottom-5 validate-warning-msg">Email is required</div>
                                       
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 margin-t-10">
                                        
                                        <input
                                            type="text"
                                            name="phone number"
                                            id="phone_number"
                                            class="col-12 col-sm-12 input-height-35 form-control"
                                            ref="phone_number"
                                            v-model="phoneNumber"
                                            v-validate="{ rules: { regex: phoneRegex(), required: true } }"
                                            placeholder="Enter Phone Number"
                                            @keyup="billingPhoneValid"
                                            @blur="billingPhoneValid"
                                            maxlength="20"
                                            autocomplete="off">
                                            <div v-show="verrors.has('phone number')" class="validate-warning-msg">Phone number field format is invalid</div>
                                        
                                    </div>
                                </div>
                                <div class="row submit_row justify-content-md-center">
                                    <div >
                                        <button type="submit" class="btn btn-sm ma-blue-btn text-center">Save</button>
                                    </div>
                                </div>
                            </form>
                            
                        </div>
                    </div>
                </div>
            </div>
        </transition>

       

    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import router from '../../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalEAdminVisible'],
    data() {
        return {
            loading: false,
            isSuccessPanel: false,
            firstName: '',
            lastName: '',
            adminEmail: '',
            phoneNumber: '',
            success_message: '',
            dismissCountDown: 0,
        }
    },    
    methods: {
        close() {
            this.verrors.clear();
            this.$emit('close');
        },
        hide() {
          this.close();
        },
        billingPhoneValid() {
            var phone = this.phoneNumber;
            this.phoneNumber = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneRegex() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        createNewEnterpriseAdmin() {
          this.$validator.validateAll().then((result) => {             
             if (this.verrors.items.length === 0) {
                axios("/create_new_enterprise_admin", {
                      method: 'POST',
                      data: {
                        admin_fname: this.firstName,
                        admin_lname: this.lastName,
                        admin_email: this.adminEmail,
                        phone: this.phoneNumber,
                      }
                    })
                    .then(response => {
                        this.flash({ message: response.data.msg, variant: 'success' });
                        this.$emit('close');
                        router.push("/enterprise");
                        location.reload();                    
                    })
                    .catch(error => {

                    });
           }
           });     
        }
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.ma-blue-btn, .ma-blue-btn:hover, .ma-blue-btn:active, .ma-blue-btn:focus {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 15px;
  font-weight: 900;
  width: 150px;
}
.closeBtn {
    color: #00acee; 
    background-color: #FFF !important;
    border: 1px solid #00acee !important;
    border-radius: 10px;
    font-weight: 900;
    width: 100%;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  background-color: #efefef;
  min-height: 30px;
  border-radius: 5px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.submit_row { margin: 2rem; }
.successPanel { 
    background-color: #28a745;
    color: #FFF;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
}
.success-msg { font-size:  1.5rem; font-weight: 900;}
.success-note i { font-size: 1.25rem; margin-right: 10px; }
.gotoBtn { margin-top: 16rem; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.back_icon { width: 14px; }
a, a:hover {
    text-decoration: none;
}
input {
    line-height: 17px;
    border-radius: 10px;
    padding-left: 5px !important;
    border: 1px solid #707070;
}
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/add_new_enterpriseadmin.vue